import React from 'react';
import './ShopCrystalsItem.css';
import PageButton from '../../../elements/PageButton/PageButton';
import {getCrystalsImagePath} from '../../../../utils/crystals/getCrystalsImagePath';
import {getFormattedPrice} from '../../../../utils/price/getFormattedPrice';
import {LoadedImage} from "../../../EmblaCarousel/FactionsCarousel";
import {MINUS_SIGN, RUBLE_SIGN} from "../../../../constants/text";

const PAGE_ID = 'ShopPage';

/**
 * Плашка набора кристаллов: цена в рублях на кнопке, у самого большого набора —
 * бейдж выгоды (как у сундуков). Покупка пока не подключена: клик по плашке
 * открывает модалку с описанием набора (см. CrystalsInfoModal)
 */
function ShopCrystalsItem({crystalsConfig, onItemClick}) {
  // Звук открытия — в самой модалке (кристалльный, как у наград за рейтинг),
  // поэтому по клику плашка молчит
  const handleClick = (event) => {
    event.stopPropagation();
    onItemClick?.(crystalsConfig);
  };

  return (
    <div
      className="shop-crystals-item"
      onClick={handleClick}
      style={{
        background: crystalsConfig.backgroundColor,
      }}
    >
      <LoadedImage
        className="shop-crystals-icon"
        src={getCrystalsImagePath(crystalsConfig.id)}
        alt={`${crystalsConfig.crystals} кристаллов`}
        placeholderSrc="/img/icons/crystal.png"
      />
      <div className="shop-crystals-amount text-crystals">
        {getFormattedPrice(crystalsConfig.crystals)}
        <img className="shop-crystals-amount-icon" src="/img/icons/crystal.png" alt="Кристаллы"/>
      </div>

      <PageButton
        className="shop-crystals-buy-button"
        onClick={handleClick}
        pageId={PAGE_ID}
        buttonId={`buy_crystals_${crystalsConfig.id}`}
        title={`Купить ${getFormattedPrice(crystalsConfig.crystals)} кристаллов`}
        noSound={true}
      >
        <span className="shop-crystals-price">
          {getFormattedPrice(crystalsConfig.priceRub)} {RUBLE_SIGN}
        </span>
        {crystalsConfig.discountPercents > 0 && (
          <span className="shop-crystals-discount-badge">
            {MINUS_SIGN}{crystalsConfig.discountPercents}%
          </span>
        )}
      </PageButton>
    </div>
  );
}

export default ShopCrystalsItem;
